import { Link } from "react-router-dom";

export default function ShopTeaser() {
  return (
    <section
      id="shop"
      data-testid="shop-teaser"
      className="bg-[#0F0F0F] border-y border-[#D4AF37]/30 py-16 px-4"
    >
      <div className="max-w-5xl mx-auto text-center">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-bold mb-3">
          The Phoenix Shop
        </div>
        <h2 className="font-display text-4xl sm:text-5xl text-white mb-3">
          Real Merch · <span className="text-[#D4AF37]">Real Phoenix.</span>
        </h2>
        <p className="text-base text-neutral-400 max-w-xl mx-auto mb-7">
          Pay with Omni Dollars ☯️ — earn them by playing, buy a pack, or burn 500 Phoenix Tokens for 1 OD.
          Caps, tees, hoodies, stickers, tumblers.
        </p>
        <div className="flex justify-center gap-4 text-3xl mb-6">
          <span>🧢</span><span>👕</span><span>🧥</span><span>✨</span><span>🥤</span>
        </div>
        <Link
          to="/shop"
          data-testid="shop-teaser-cta"
          className="inline-block bg-[#D4AF37] hover:bg-[#F1C84B] text-[#0A0A0A] font-bold uppercase tracking-[0.2em] text-sm px-7 py-4 transition-all"
        >
          Enter the Shop →
        </Link>
      </div>
    </section>
  );
}
